import { cn } from "../../../utils/cn";

type TProps = {
  className?: string;
};
export const Spinner = (props: TProps) => {
  const { className } = props;
  return (
    // <ImSpinner8
    //   className={cn("mx-auto h-6 w-5 animate-spin", className && className)}
    // />
    <LoaderSpinner
      className={cn("mx-auto h-6 w-5 animate-spin", className && className)}
    />
  );
};

type LoaderSpinnerProps = {
  className?: string;
  speed?: 1 | 2 | 3 | 4;
};

const SPEED_DURATION: Record<number, string> = {
  1: "1s",
  2: "0.75s",
  3: "0.5s",
  4: "0.25s",
};

export const LoaderSpinner = (props: LoaderSpinnerProps) => {
  const { className, speed = 1 } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 16 17"
      fill="none"
      style={{ animationDuration: SPEED_DURATION[speed] }}
      className={cn("animate-spin", className)}
    >
      <g clipPath="url(#clip0_2652_20149)">
        {/* Top hand */}
        <path
          d="M8 4.5V2.5"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        {/* Other hands */}
        <path
          d="M10.8333 5.66667L12.2666 4.23334"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 8.5H14"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.8333 11.3333L12.2666 12.7666"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 12.5V14.5"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.16649 11.3333L3.73315 12.7666"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 8.5H2"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.16649 5.66673L3.73315 4.2334"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2652_20149">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
